/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AgentPresenceEvent,
  AgentPresenceEvent$inboundSchema,
  AgentPresenceEvent$Outbound,
  AgentPresenceEvent$outboundSchema,
} from "./agentpresenceevent.js";

/**
 * Websocket event type
 */
export const UserActivityEventType = {
  AlarmActivation: "alarm_activation",
  Error: "error",
  Keepalive: "keepalive",
  Reading: "reading",
  Setting: "setting",
  ShutdownBanner: "shutdown_banner",
  Trends: "trends",
  UserActivity: "user_activity",
} as const;
/**
 * Websocket event type
 */
export type UserActivityEventType = OpenEnum<typeof UserActivityEventType>;

/**
 * Stream of agent events
 */
export type UserActivityEvent = {
  /**
   * The trace metadata, initialized by the trace stream interceptor
   */
  traceMetadata?: { [k: string]: string } | undefined;
  /**
   * Event indicating that an agent has gone on- or offline.
   */
  agentPresence?: AgentPresenceEvent | undefined;
  /**
   * Websocket event type
   */
  type?: UserActivityEventType | undefined;
};

/** @internal */
export const UserActivityEventType$inboundSchema: z.ZodType<
  UserActivityEventType,
  z.ZodTypeDef,
  unknown
> = openEnums.inboundSchema(UserActivityEventType);
/** @internal */
export const UserActivityEventType$outboundSchema: z.ZodType<
  string,
  z.ZodTypeDef,
  UserActivityEventType
> = openEnums.outboundSchema(UserActivityEventType);

/** @internal */
export const UserActivityEvent$inboundSchema: z.ZodType<
  UserActivityEvent,
  z.ZodTypeDef,
  unknown
> = z.object({
  TraceMetadata: types.optional(z.record(types.string())),
  agent_presence: types.optional(AgentPresenceEvent$inboundSchema),
  type: UserActivityEventType$inboundSchema.default("user_activity"),
}).transform((v) => {
  return remap$(v, {
    "TraceMetadata": "traceMetadata",
    "agent_presence": "agentPresence",
  });
});
/** @internal */
export type UserActivityEvent$Outbound = {
  TraceMetadata?: { [k: string]: string } | undefined;
  agent_presence?: AgentPresenceEvent$Outbound | undefined;
  type: string;
};

/** @internal */
export const UserActivityEvent$outboundSchema: z.ZodType<
  UserActivityEvent$Outbound,
  z.ZodTypeDef,
  UserActivityEvent
> = z.object({
  traceMetadata: z.record(z.string()).optional(),
  agentPresence: AgentPresenceEvent$outboundSchema.optional(),
  type: UserActivityEventType$outboundSchema.default("user_activity"),
}).transform((v) => {
  return remap$(v, {
    traceMetadata: "TraceMetadata",
    agentPresence: "agent_presence",
  });
});

export function userActivityEventToJSON(
  userActivityEvent: UserActivityEvent,
): string {
  return JSON.stringify(
    UserActivityEvent$outboundSchema.parse(userActivityEvent),
  );
}
export function userActivityEventFromJSON(
  jsonString: string,
): SafeParseResult<UserActivityEvent, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UserActivityEvent$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UserActivityEvent' from JSON`,
  );
}
